<template>
  <b-modal
    id="addComment"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="showAddComment"
    @hidden="$emit('close-modal')"
  >
    <div>
      <div class="d-flex align-items-center justify-content-between p-3">
        <div class="b-modal-header">{{ heading }}</div>
        <div class="rotate-on-hover pointer">
          <img
            @click="$emit('close-modal')"
            v-b-tooltip.hover.top="'Close'"
            src="../../../assets/img/accessconnew/blueCross.svg"
            alt
          />
        </div>
      </div>
      <hr class="my-0" />

      <div class="p-4">
        <div class="topDiv mb-4" v-if="type === 'onboard'">
          <DateField
            format="DD-MM-YYYY"
            type="date"
            :vmodel="date"
            :label="'Onboarding Date'"
            :mandatory="true"
            :showError="$v.date.$error"
            placeholder="Select date"
            id="offer-date"
            @select-value="date = $event"
          />
          <div
            class="errortxt position-absolute mt-1"
            v-if="$v.date.$dirty && !$v.date.required"
          >
            Required
          </div>
        </div>
        <div class="topDiv">
          <div>
            <label class="b-modal-inputs-heading"
              >{{ label
              }}<span v-if="remarksRequired" class="asterik">*</span></label
            >
          </div>
          <div class="mt-1">
            <b-form-textarea
              class="newInt-previewInputField"
              placeholder="Enter"
              rows="3"
              max-rows="4"
              v-model.trim="$v.remarks.$model"
              :class="{ error: $v.remarks.$error }"
            >
            </b-form-textarea>
            <div
              class="errortxt position-absolute"
              v-if="$v.remarks.$dirty && !$v.remarks.required"
            >
              Required
            </div>
            <div
              class="errortxt position-absolute"
              v-else-if="!$v.remarks.maxLength"
            >
              Exceeded the max char length of 256
            </div>
          </div>
        </div>
      </div>

      <hr class="my-0" />

      <div class="d-flex align-items-center justify-content-end bluebtn p-3">
        <b-button class="acs-cancelBtn-modal mr-3" @click="$emit('close-modal')"
          >Cancel</b-button
        >
        <div class="position-relative">
          <b-button
            style="text-transform: capitalize"
            class="acs-addBtn-modal w-105px"
            :class="showLoader ? 'send-loader-class defaultCursor' : 'pointer'"
            @click="btn2Action"
            >{{ showLoader ? "" : "Save" }}</b-button
          >
          <div v-if="showLoader" class="send-loader-pos">
            <Loader />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { requiredIf, maxLength } from "vuelidate/lib/validators";
import Loader from "../../fixedcomponents/Loader.vue";
import DateField from "../../InputComponents/DateField.vue";
export default {
  name: "KanbanComment",
  props: {
    type: String,
    label: String,
    showAddComment: Boolean,
    heading: String,
    remarksRequired: Boolean,
  },
  components: {
    Loader,
    DateField,
  },
  data() {
    return {
      remarks: "",
      date: "",
      showLoader: false,
    };
  },

  validations: {
    remarks: {
      required: requiredIf(function () {
        return this.remarksRequired;
      }),
      maxLength: maxLength(256),
    },
    date: {
      required: requiredIf(function () {
        return this.type === "onboard";
      }),
    },
  },

  methods: {
    btn2Action() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.showLoader = true;
        let emitDate = this.date;
        if (this.date) {
          const parts = this.date.split("-");
          if (parts.length === 3 && parts[0].length <= 2) {
            emitDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
        }
        this.$emit("btn2-action", this.remarks, emitDate);
      }
    },
  },
};
</script>

<style scoped>
.newInt-previewInputField.form-control {
  font-weight: 500;
  color: #333;
}
</style>
